export default {
  ArticleCover: 'Article Cover',
};
